"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_type_1 = require("./is-type");
exports.default = (function (value) {
    return Array.isArray ?
        Array.isArray(value) :
        is_type_1.default(value, 'Array');
});
//# sourceMappingURL=is-array.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-array.js
// module id = 50
// module chunks = 37